module.exports = __webpack_public_path__ + "static/media/icon_house_white.a93641c7.svg";